// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InfoCard2_wrapper__2jhQH"};